/**
 * Waiting, drawn rather than spelled out: four squares chasing each other round a corner. It takes the colour of the
 * text around it, so it suits the light theme and the dark one without being told which is on, and the words it stands
 * in for stay in the page for anyone listening to it.
 */
export function Loader({ label }: { label: string }) {
  return (
    <>
      <span className="loader" aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </>
  )
}
